import React from 'react';
import PropTypes from 'prop-types';
import T from '@prisjakt/ui-translate';
import Currency from '@prisjakt/ui-currency';

const PriceSummary = ({ productName, priceSummary, prices }) => {
  const { regular } = priceSummary || {};
  if (!regular) {
    return null;
  }
  const priceUsed =
    prices && Array.isArray(prices.nodes)
      ? prices.nodes.find(
          item =>
            item.type === 'used_product' && // Consider checking 'not_in_mint_condition'?
            item.store &&
            item.store.market === 'primary' &&
            item.stock &&
            (item.stock.status === 'in_stock' || item.stock.status === null)
        )
      : null;
  return priceUsed &&
    priceUsed.price &&
    priceUsed.price.exclShipping < regular ? (
    <T
      domain="product"
      product={productName}
      price={<Currency price={regular} />}
      priceUsed={<Currency price={priceUsed.price.exclShipping} />}
    >
      product-info.price-used
    </T>
  ) : (
    <T
      domain="product"
      product={productName}
      price={<Currency price={regular} />}
    >
      product-info.price
    </T>
  );
};

const { string, number, shape, arrayOf } = PropTypes;

PriceSummary.propTypes = {
  productName: string,
  priceSummary: shape({
    alternative: number,
    regular: number,
  }),
  prices: shape({
    nodes: arrayOf(
      shape({
        price: shape({
          exclShipping: number,
          inclShipping: number,
        }),
        type: string,
      })
    ),
  }),
};

PriceSummary.defaultProps = {
  productName: undefined,
  priceSummary: undefined,
  prices: undefined,
};

export default PriceSummary;
